export class Usuario {

    constructor(
        public nombre: string = '',
        public userId: string = '',
        public userName: string = '',
        public apellido: string = '',
        public rol: string = '',
        public sucNombre: string = '',
        public sucId: string = '',
        public imagenPerfil = '',
        public permisos = []
    ) { }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_model/Usuario.ts